import CAROUSEL_NLP_IMAGE from "../static/carousel_nlp.svg"
import CAROUSEL_CONTEXT_RETENTION from "../static/carousel_context_retention.svg"
import CAROUSEL_NARRATIVE_INSIGHTS from "../static/carousel_narrative_insights.svg"
import CAROUSEL_NARRATIVE_BOARD from "../static/carousel_narrative_board.svg"
import CAROUSEL_DATA_OPTION from "../static/carousel_data_option.svg"
import CAROUSEL_NUDGES from "../static/carousel_nudges.svg"
export const BASEURL = process.env.REACT_APP_API_BASE_URL || `https://${window.location.hostname}`
/**
 * @module constants
 * 
 * @description This module contains various constant values used throughout the application.
 * It includes constants for header configuration, error messages, sidebar options,
 * login prompts, chat settings, and about section details.
 * These constants help maintain consistency and make it easier to manage
 * static values used in the UI and application logic.
 * 
 * @example
 * import { ERRORMESSAGES, LOGINCONST } from './constants';
 * console.log(ERRORMESSAGES.INTERNETLOSS); // Outputs the internet loss error message
 * console.log(LOGINCONST.WELCOME); // Outputs "Welcome!"
 * // These constants can be used throughout the application to ensure consistency in messaging and UI elements.
 * // This module is essential for maintaining a clean and organized codebase by centralizing static values.
 */

/**
 * Header related constants
 * Includes logout text and user icon URL
 * @constant {object} HEADERCONST
 */
export const HEADERCONST={
    LOGOUT:"LOGOUT",
    USERICONURL:"https://react.semantic-ui.com/images/avatar/small/elliot.jpg"
}

/**
 * Standardized error messages for user feedback
 * Includes messages for internet loss, message sending errors, and redirection notices
 * @constant {object} ERRORMESSAGES
 */
export const ERRORMESSAGES = {
    INTERNETLOSS: "Oops! It looks like you're offline. Please connect to the internet to continue using our application.",
    ERRORMESSAGESENDING: "Error sending message",
    FAILEDTOFETCHPASTACTIVITIES: "Failed to fetch past activities",
    ERRORFETCHINGPASTACTIVITIES: "Error fetching past activities",
    REDIRECTTOLOGIN: "Redirecting to Login..."
}

/**
 * Sidebar navigation options
 * Includes labels for Chat, Files, Notification, and About sections
 * @constant {object} SIDEBARCONST
 */
export const SIDEBARCONST = {
 CHAT:"Chat",
 FILES:"Files",
 NOTIFICATION:"Notification",
 ABOUT:"About"
}

/**
 * Login interface text and placeholders
 * Includes welcome message, sign-in prompts, and placeholders for username and password
 * @constant {object} LOGINCONST
 */
export const LOGINCONST = {
WELCOME:"Welcome!",
SIGNINMESSAGE:"Please sign in to your account",
USERNAMEPLACEHOLDER:"Enter User Name",
PASSWORDPLACEHOLDER:"Enter Password",
SIGNIN:"SIGN IN",
LOGIN:"Login",
PASSWORD:"Password",
EMAILADDRESS:"Email Address",
WELCOMEBEAGLEGPT:"Welcome to BeagleGPT!",
GENAIASSISTANT:"GenAI powered knowledge assistant"
}

/**
 * Chat functionality and UI constants
 * Includes app name, typing indicator URL, send button text, and query placeholder
 * @constant {object} CHATCONST
 */
export const CHATCONST ={
BEAGLEGPT:"BeagleGPT",
TYPINGURL:"https://media.tenor.com/860XF6cSCusAAAAi/microsoft-microsoft365.gif",
SEND:"Send",
QUERYPLACEHOLDER:"Get answers from your data"
}

/**
 * About section information and text
 * Includes descriptions, key features, contact text, and role information
 * @constant {object} ABOUTCONST
 */
export const ABOUTCONST = {
GENAIDESC:"GenAI powered knowledge assistant",
DEEPDIVETEXT:"Unleash BeagleGPT's Teams chat analysis power on web! Dive deeper anytime, anywhere to interact with your data, making insights accessible to everyone in your organization.",
KEYFEATURES:"Key Features:",
CONTACTUSTEXT:"Getting Started:To harness the power of Beagle, ensure you have an active Beagle GPT account. For setup and inquiries, contact us at ",
ROLESTEXT:`BeagleGPT for Everyone!  Equip every role (leaders, analysts, sales reps) to access data and gain insights on the go. Make informed decisions with our user-friendly interface and collaborative features. Explore today and revolutionize your organization's data interaction!`
}

export const EMAIL_BEAGLE = "beagle@decisionpoint.in"
export const MOBILE_WIDTH = 440
export const ERROR_MESSAGE_TIMEOUT = 5000;

/**
 * Sidebar feature visibility configuration.
 * Toggle individual nav items on/off without changing component code.
 * @constant {object} SIDEBAR_CONFIG
 */
export const SIDEBAR_CONFIG = {
  showNotification: false,
};

/**
 * Array of image paths for the about section carousel
 * @constant {array} ABOUT_CAROUSEL_IMAGES
 */
export const ABOUT_CAROUSEL_IMAGES =[CAROUSEL_NLP_IMAGE,CAROUSEL_CONTEXT_RETENTION,CAROUSEL_NARRATIVE_INSIGHTS,CAROUSEL_NUDGES,CAROUSEL_NARRATIVE_BOARD,CAROUSEL_DATA_OPTION]

/**
 * Storage key constants — centralized to avoid magic strings.
 * @constant {object} STORAGE_KEYS
 */
export const STORAGE_KEYS = {
  SESSION: "webAppDirectline",
  LOGOUT_FLAG: "beagle_explicit_logout",
  THEME: "beagle-theme",
  // The agent run this TAB is watching (sessionStorage, see utils/activeAgentRun.js).
  // A run's stream URL arrives once, on a `typing` frame that is deliberately never
  // stored in history — so navigating away and back left the browser with no handle to
  // a run that was still working, and the progress card vanished for the rest of it.
  // Remembering it here is what lets a remount reattach.
  ACTIVE_AGENT_RUN: "beagleActiveAgentRun",
  WORKING_PANEL: "beagleWorkingPanel",
};